var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSpecialistManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5956 21.4303H20.2904C22.808 21.4303 24.223 18.7385 22.1276 17.3429C21.2866 16.7828 20.3701 16.3273 19.3966 15.9949",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 12.5022C15.3314 12.6169 15.816 12.6755 16.3462 12.6755C19.043 12.6755 20.56 11.1586 20.56 8.46172C20.56 5.76488 19.043 4.24792 16.3462 4.24792C16.3148 4.24792 16.2835 4.24813 16.2524 4.24854",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1834 17.001C18.4541 18.5134 16.9208 21.4301 14.1926 21.4301H3.94739C1.21919 21.4301 -0.314077 18.5134 1.95659 17.001C3.99332 15.6445 6.43933 14.8539 9.06998 14.8539C11.7006 14.8539 14.1467 15.6445 16.1834 17.001Z",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07344 11.8537C12.0444 11.8537 13.7155 10.1825 13.7155 7.21163C13.7155 4.24072 12.0444 2.56958 9.07344 2.56958C6.10253 2.56958 4.4314 4.24072 4.4314 7.21163C4.4314 10.1825 6.10253 11.8537 9.07344 11.8537Z",
    stroke: "#4A57DA",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSpecialistManager);
export default __webpack_public_path__ + "static/media/ActiveSpecialistManager.3b156c3c4036161b865bc607545485d0.svg";
export { ForwardRef as ReactComponent };